namespace advisorop.domains {
    "use strict";

    export interface IBackOfficeOrionParams {
        backOfficeLevel?: string;
        backOfficeEntityId?: number;
    }

    export interface IBackOfficeParams {
        backOfficeLevel?: string;
        backOfficeEntityId?: string;
    }
}